module.exports = __webpack_public_path__ + "img/int15.ec8c63ba.jpg";